import { render, staticRenderFns } from "./BasicListLoader.vue?vue&type=template&id=14ef030a&scoped=true"
import script from "./BasicListLoader.vue?vue&type=script&lang=js"
export * from "./BasicListLoader.vue?vue&type=script&lang=js"
import style0 from "./BasicListLoader.vue?vue&type=style&index=0&id=14ef030a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14ef030a",
  null
  
)

export default component.exports